export const TYPE_LINESHEET = "linesheet";
export const TYPE_CUSTOM_LIST = "custom-list";
export const ITEM_SEPARATOR = "separator";
export const ITEM = "item";
export const MAX_PRODUCTS_PER_CALL = 20;
export const SCROLL_HEIGHT_MULTIPLIER = 1.5;
